module.exports = __webpack_public_path__ + "img/multiplataforma.946c68b5.png";